import { APP_HEADER_TITLE_EN, APP_HEADER_TITLE_JA } from '@env';

export const getHeaderTitle = (language?: string): string => {
  const LanguageMap: Record<string, string> = {
    en: APP_HEADER_TITLE_EN,
    ja: APP_HEADER_TITLE_JA,
  };
  return LanguageMap[language ?? ''] ?? APP_HEADER_TITLE_EN;
};
